// CRITICAL: Import React polyfill FIRST before any other imports
import "./react-polyfill";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./lib/queryClient";
import "./index.css";
import App from "./App";
import { ThemeProvider } from "./contexts/ThemeContext";

// Defer non-critical initialization to avoid blocking render
if (typeof window !== "undefined") {
  const deferInit = () => {
    import("./utils/web-vitals")
      .then(({ initWebVitals }) => initWebVitals())
      .catch(() => {});
    // Prefetch most-likely next routes once the browser is idle
    import("./lib/routePrefetch")
      .then(({ schedulePrefetch }) => schedulePrefetch(["/menu", "/reservations"]))
      .catch(() => {});
  };

  if ("requestIdleCallback" in window) {
    requestIdleCallback(deferInit, { timeout: 3000 });
  } else {
    setTimeout(deferInit, 1000);
  }
}

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

// Render immediately without blocking checks
createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <HelmetProvider>
        <ThemeProvider>
          <App />
        </ThemeProvider>
      </HelmetProvider>
    </QueryClientProvider>
  </StrictMode>,
);
